{
  "逐帧翻一段真机示范 · 物理AI实验室 Lab 1.5": {
    "en": "A real-robot demo, frame by frame · Physical AI Lab 1.5",
    "ja": "実機デモを1コマずつ · Physical AI Lab 1.5"
  },
  "逐帧翻一段真机示范": {
    "en": "A real-robot demo, frame by frame",
    "ja": "実機デモを1コマずつめくる"
  },
  "人手遥控 SO-101 机械臂，把粉色积木放进透明盒子，录了 50 段。每一帧：两路相机的画面，加 6 个关节的读数。": {
    "en": "A person teleoperates an SO-101 arm to put a pink brick in a clear box, 50 times. Each frame: two camera images plus 6 joint readings.",
    "ja": "人が SO-101 アームを遠隔操作し、ピンクのブロックを透明な箱へ入れる様子を 50 本収録。各フレームは、カメラ2台の画像と 6 関節の読み値です。"
  },
  "第 <span id=\"epNo\">0</span> 段 · 两路相机 <span style=\"float:right\" class=\"mono\" id=\"task\"></span>": {
    "en": "Episode <span id=\"epNo\">0</span> · two cameras <span style=\"float:right\" class=\"mono\" id=\"task\"></span>",
    "ja": "第 <span id=\"epNo\">0</span> 本 · カメラ2台 <span style=\"float:right\" class=\"mono\" id=\"task\"></span>"
  },
  "俯视 · up": {
    "en": "overhead · up",
    "ja": "俯瞰 · up"
  },
  "侧视 · side": {
    "en": "side",
    "ja": "側面 · side"
  },
  "帧 <b id=\"frame\">0</b> / <span id=\"frames\">0</span>（30 fps）": {
    "en": "Frame <b id=\"frame\">0</b> / <span id=\"frames\">0</span> (30 fps)",
    "ja": "フレーム <b id=\"frame\">0</b> / <span id=\"frames\">0</span>（30 fps）"
  },
  "时间": {
    "en": "Time",
    "ja": "時間"
  },
  "示范段": {
    "en": "Episode",
    "ja": "デモ"
  },
  "帧": {
    "en": "Frame",
    "ja": "フレーム"
  },
  "播放": {
    "en": "Play",
    "ja": "再生"
  },
  "6 个关节 · 读数": {
    "en": "6 joints",
    "ja": "6 関節 · 読み値"
  },
  "— 这一段": {
    "en": "— this one",
    "ja": "— この回"
  },
  "▮ 50 段的范围（±1σ）": {
    "en": "▮ all 50 (±1σ)",
    "ja": "▮ 50 本の範囲（±1σ）"
  },
  "选一段示范 · 拖帧 · 橙色：这一刻离 50 段的平均超过 2 个标准差": {
    "en": "Pick an episode · drag the frames · amber: more than 2 standard deviations from the mean of all 50",
    "ja": "デモを選ぶ · フレームをドラッグ · オレンジ：50 本の平均から標準偏差 2 つ以上離れた瞬間"
  },
  "底座转": {
    "en": "Base pan",
    "ja": "台座回転"
  },
  "肩抬": {
    "en": "Shoulder",
    "ja": "肩上げ"
  },
  "肘弯": {
    "en": "Elbow",
    "ja": "肘曲げ"
  },
  "腕弯": {
    "en": "Wrist flex",
    "ja": "手首曲げ"
  },
  "腕转": {
    "en": "Wrist roll",
    "ja": "手首回転"
  },
  "夹爪": {
    "en": "Gripper",
    "ja": "グリッパ"
  },
  "这一段没有打包画面（只打包了第 0 段和最不一样的一段）；关节读数照常显示。": {
    "en": "No frames packed for this episode (only episode 0 and the most unusual one); joint readings still show.",
    "ja": "この回の画像は同梱していません（第 0 本と最も違う1本のみ）。関節の読み値は通常どおり表示します。"
  },
  "! {0}离 50 段平均 &gt; 2σ": {
    "en": "! {0} &gt; 2σ from the mean of 50",
    "ja": "! {0}が 50 本の平均から &gt; 2σ"
  },
  "这是 50 段里<b>和其余最不一样</b>的一段：平均偏离 {0} 个标准差（50 段的中位数是 {1}）。": {
    "en": "Of the 50, this one is <b>the most unlike the rest</b>: {0} standard deviations off on average (the median of the 50 is {1}). ",
    "ja": "50 本のうち<b>他と最も違う</b>1本です。平均のずれは標準偏差 {0} 個分（50 本の中央値は {1}）。"
  },
  "最大的一处在进度 {0}%，{1}偏了 {2}σ。它不一定是“错的”示范，但训练前值得看一眼：积木放在了别处，动作就跟着不一样。": {
    "en": "The biggest gap is at {0}% progress: {1} off by {2}σ. Not necessarily a \"wrong\" demo, but worth a look before training: the brick sat elsewhere, so the motion differs.",
    "ja": "最大のずれは進行度 {0}% の所で、{1}が {2}σ。「間違った」デモとは限りませんが、学習前に一度確かめたい所です。ブロックの位置が違えば動きも変わります。"
  },
  "灰带是 50 段在同一进度上通常所在的范围（均值 ± 1σ）。跑偏的地方会变成橙色：试试第 {0} 段。": {
    "en": "The grey band is where the 50 episodes usually are at the same progress (mean ± 1σ). Where one strays it turns amber: try episode {0}.",
    "ja": "灰色の帯は、50 本が同じ進行度でふだんいる範囲（平均 ± 1σ）。外れるとオレンジになります。第 {0} 本を試してください。"
  },
  "数据：{0}（Apache-2.0）· {1} 段 · {2} 帧 · 关节读数按 {3} Hz 取样": {
    "en": "Data: {0} (Apache-2.0) · {1} episodes · {2} frames · joints sampled at {3} Hz",
    "ja": "データ：{0}（Apache-2.0）· {1} 本 · {2} フレーム · 関節は {3} Hz でサンプリング"
  }
}
